<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h1>{{ model.processName }}</h1>
    <!-- status -->
    <b-row>
      <b-col cols="7">
        <label for="select-status">
          <b-row>
            <b-col cols="12" md="auto">Status</b-col>
            <b-col class="required">*</b-col>
          </b-row>
        </label>
        <b-input-group>
          <b-form-select
            id="select-status"
            class="status"
            :options="options"
            v-model="statusId"
          >
          </b-form-select>
        </b-input-group>

        <!-- <b-form-group label="Status" label-for="input-process-displayName">
          <b-form-select
            class="status"
            :options="options"
            v-model="statusId"
          ></b-form-select>
        </b-form-group> -->
      </b-col>
    </b-row>
    <span class="text-danger" v-if="modelstate['StatusId']">
      {{ modelstate["StatusId"][0] }}
    </span>
    <!-- {{ model.values }} -->
    <b-row v-for="field in model.values" :key="field.fieldId">
      <b-col>
        <workflow-fill-field
          :field="field"
          :fieldId="field.fieldId"
          :modelstate="modelstate"
          :stage="false"
        >
        </workflow-fill-field>
      </b-col>
    </b-row>

    <!-- Campos adicionais da etapa -->
    <b-row v-for="field in model.additionalFields" :key="field.fieldId">
      <b-col>
        <workflow-fill-field
          ref="fields"
          :field="field"
          :fieldId="field.fieldId"
          :modelstate="modelstate"
          :trip.sync="trip"
          :dateEnd.sync="dateEnd"
          :stage="true"
          @new-value="newValue"
        >
        </workflow-fill-field>
      </b-col>
    </b-row>
    <div>
      <!-- {{ model }} -->
    </div>
    <b-button :disabled="submitted" @click="save()">
      {{ $t("geral.save") }}
    </b-button>

    <!-- <pre class="language-json"><code>statusId: {{ statusId }}</code></pre> -->
    <!-- <pre class="language-json"><code>options: {{ options }}</code></pre> -->
    <!-- <pre class="language-json"><code>model: {{ model }}</code></pre> -->
    <!-- <pre class="language-json"><code>Trip: {{ trip }}</code></pre> -->
    <!-- <pre class="language-json"><code>model.values: {{ model.values  }}</code></pre> -->
    <!-- <pre class="language-json"><code>model.additionalFields: {{ model.additionalFields  }}</code></pre> -->
    <!-- <pre class="language-json"><code>modelstate: {{ modelstate  }}</code></pre> -->
  </b-container>
</template>
<script>
export default {
  name: "WorkflowFill",
  props: {
    id: String,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    WorkflowFillField: () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Processo criado com sucesso",
      },
      model: {},
      submitted: false,
      options: [],
      statusId: null,
      modelstate: {},
      trip: {
        dateBegin: "",
        dateEnd: "",
        hourBegin: "",
        hourEnd: "",
        timeTotal: "",
      },
      dateEnd: "",
    };
  },
  created() {
    this.getProcess();
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.$apiWorkflow.get("/stage/allStage/" + this.id).then((response) => {
        this.options = response.data;
      });
    },
    getProcess() {
      this.$apiWorkflow
        .get(`/processFilled/new/${this.id}`)
        .then((response) => {
          this.model = response.data;
          if (this.options.length > 0) {
            this.statusId = this.options[0].value;
          }
          this.getPosition();
          // this.getField();
        });
    },
    getAdditionalFields() {
      this.$apiWorkflow
        .get("/stage/addtionalFields/" + this.statusId + "/" + this.id)
        .then((response) => {
          this.model.additionalFields = response.data;
        });
    },
    async save() {
      this.submitted = true;
      await this.$apiWorkflow
        .post("/fieldValue/save/", this.model)
        .then((response) => {
          this.$refs.alert.show();
          this.submitted = false;
          this.model = {};
          this.getProcess();
          this.statusId = null;
          this.trip.dateBegin = "";
          this.trip.dateEnd = "";
          this.trip.hourBegin = "";
          this.trip.hourEnd = "";
          this.timeTotal = "";
        })
        .catch((error) => {
          this.submitted = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = {};
              }
              console.log(error.response.data);
              this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
              this.$refs.danger.show();
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
      this.submitted = false;
    },
    getPosition() {
      navigator.geolocation.getCurrentPosition(this.success, this.error);
    },
    success(pos) {
      var crd = pos.coords;
      this.model.latitude = crd.latitude;
      this.model.longitude = crd.longitude;
    },
    error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    },
    getField() {
      this.$apiWorkflow
        .get("/processFilled/getFields/" + this.id)
        .then((response) => {
          this.model.values = response.data;
        });
    },
    newValue() {
      this.model.additionalFields.forEach((field) => {
        if (field.isTripPlanDateEnd) {
          field.value = this.trip.dateEnd;
        }
        if (field.isTripPlanHourEnd) {
          field.value = this.trip.hourEnd;
        }
        if (field.isTripPlanDateBegin) {
          field.value = this.trip.dateBegin;
        }
        if (field.isTripPlanHourBegin) {
          field.value = this.trip.hourBegin;
        }
      });
    },
  },
  watch: {
    statusId() {
      this.model.statusId = this.statusId;
      this.getAdditionalFields();
    },
    dateEnd() {
      // this.model.additionalFields.forEach((field) => {
      //   if (field.isTripPlanDateEnd) {
      //     console.log(field);
      //     field.value = this.dateEnd;
      //     this.$refs.fields.$forceUpdate;
      //     this.$forceUpdate();
      //   }
      // });
    },
  },
};
</script>
<style scoped>
.status {
  width: 54%;
}
</style>
